import BaseAddress from './baseAddress';
import Country from './country';
import { ICountry } from './ICountry';

export default class BaseAddressWithCountry extends BaseAddress implements ICountry {
  countryId: string;
  country: Country;

  constructor(address?) {
    super(address);

    if (address) {
      this.countryId = address.countryId;
      this.country = new Country(address.country);
    }
  }
}
